import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'y42-context-menu-text-highlight',
  styleUrls: ['context-menu-text-highlight.component.scss'],
  templateUrl: './context-menu-text-highlight.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContextMenuTextHighlightComponent {
  @Input()
  highlight?: string;

  @Output()
  highlightChanged = new EventEmitter<string | undefined>();
}
